(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/rules/lotto.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/rules/lotto.js'); 
'use strict';

var _svs$numbergames, _svs$numbergames$prod;
const LOTTO = {
  productId: (_svs$numbergames = svs.numbergames) === null || _svs$numbergames === void 0 ? void 0 : (_svs$numbergames$prod = _svs$numbergames.productMapping) === null || _svs$numbergames$prod === void 0 ? void 0 : _svs$numbergames$prod.CONSTANTS.LOTTO,
  rowPrice: 3,
  numbersMaxValue: 35,
  numbersMaxLength: 7,
  maxNumberOfRows: 15,
  usesJoker: true,
  defaultJokerPrice: 10,
  rowPriceMulti: [2],
  winConditions: [{
    numbers: 4
  }],
  possibleDrawCounts: [{
    value: '1',
    label: '1 V'
  }, {
    value: '2',
    label: '2 V'
  }, {
    value: '5',
    label: '5 V'
  }, {
    value: '10',
    label: '10 V'
  }],
  PACKAGES: {
    40: {
      rows: 5,
      hasJoker: true,
      jokerPrice: 10
    },
    100: {
      rows: 15,
      hasJoker: true,
      jokerPrice: 10
    },
    200: {
      rows: 30,
      hasJoker: true,
      jokerPrice: 20
    }
  },
  SYSTEM: {
    LIMITS: {
      NUMBERS: {
        minRowLength: 8,
        maxRowLength: 12,
        combinationMinLength: {},
        combinationMaxLength: {}
      }
    }
  }
};
if (svs.isServer) {
  module.exports = {
    LOTTO
  };
} else {
  svs.numbergames.rules.LOTTO = LOTTO;
}
 })(window);